// =============================================================================
// Grid Utils - Funzioni di calcolo per posizionamento nella griglia
// =============================================================================

import { parseISO, differenceInMinutes } from 'date-fns';
import { wallClockToUtc, type CivilDate } from '../../../lib/tenantTime';

export interface AppointmentStyle {
  left: string;
  width: string;
}

/** Genera l'array di ore visibili nella griglia */
export function buildGridHours(startHour: number, endHour: number): number[] {
  const hours: number[] = [];
  for (let h = startHour; h < endHour; h++) hours.push(h);
  return hours;
}

/** Calcola i minuti totali della griglia */
export function calcTotalGridMinutes(startHour: number, endHour: number): number {
  return (endHour - startHour) * 60;
}

/**
 * Calcola left + width CSS per un appuntamento nella griglia.
 *
 * L'origine della griglia (gridStartHour) e' un orario di parete
 * dell'ORGANIZZAZIONE: va ancorato al suo giorno civile e al suo fuso, non
 * ricavato dai campi locali dell'istante, che sono quelli del browser.
 */
export function getAppointmentStyle(
  scheduledStart: string,
  scheduledEnd: string,
  gridStartHour: number,
  totalGridMinutes: number,
  civilDay: CivilDate,
  timeZone: string,
): AppointmentStyle {
  const start = parseISO(scheduledStart);
  const end = parseISO(scheduledEnd);
  const dayStart = wallClockToUtc(civilDay, gridStartHour * 60, timeZone);
  const startOffset = differenceInMinutes(start, dayStart);
  const duration = differenceInMinutes(end, start);
  return {
    left: `${(startOffset / totalGridMinutes) * 100}%`,
    width: `${(duration / totalGridMinutes) * 100}%`,
  };
}

/** Formatta la chiave di un attributo custom per visualizzazione */
export function formatAttributeKey(key: string): string {
  return key.replace(/([A-Z])/g, ' $1').replace(/^./, s => s.toUpperCase()).trim();
}

/** Formatta il valore di un attributo custom per visualizzazione */
export function formatAttributeValue(value: unknown): string {
  if (typeof value === 'boolean') return value ? 'Sì' : 'No';
  if (Array.isArray(value)) return value.join(', ');
  return String(value ?? '');
}
